import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter, DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview as AccessKeyOverview } from 'domains/Showcases/Collections/AccessKeys'
import { JSON, Dashboard as CollectionDashboard } from 'domains/Showcases/Collections/Config'
import { Overview as ShowcaseOverview } from 'domains/Showcases/Collections/Showcases'
import { Structure } from 'pages/NWPlatform/Collections/Collection/Structure'
import { collectionsRoute } from 'pages/NWPlatform/Collections/Routing'

export const collectionRoute = createRoute({
  getParentRoute: () => collectionsRoute,
  path: DynamicRouteParameterWPrefix.COLLECTION_ID,
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith(params.collectionId) || location.pathname.endsWith(`${params.collectionId}/`)) {
      throw redirect({ replace: true, from: collectionRoute.fullPath, to: configRoute.to })
    }
  },
  loader: () => ({
    crumb: t('entity:showcase.collection', { count: 1 }),
  }),
})

export const collectionLayoutRoute = createRoute({
  getParentRoute: () => collectionRoute,
  id: 'collectionLayout',
  component: Structure,
})

export const configRoute = createRoute({
  getParentRoute: () => collectionLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: CollectionDashboard,
})

type ShowcasesOverviewSearch = {
  query?: string
}

export const showcasesOverviewRoute = createRoute({
  getParentRoute: () => collectionLayoutRoute,
  path: StaticRouteParameter.SHOWCASES,
  component: ShowcaseOverview,
  validateSearch: (search: Record<string, unknown>): ShowcasesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type ShowcaseCollectionAccessKeysSearch = {
  query?: string
}

export const accessKeysOverviewRoute = createRoute({
  getParentRoute: () => collectionLayoutRoute,
  path: StaticRouteParameter.ACCESS_KEYS,
  component: AccessKeyOverview,
  validateSearch: (search: Record<string, unknown>): ShowcaseCollectionAccessKeysSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

export const rawRoute = createRoute({
  getParentRoute: () => collectionLayoutRoute,
  path: StaticRouteParameter.RAW,
  component: JSON,
})
